import useChatConnections from 'hooks/redux/useChatConnections'
import React from 'react'
import ChatMessages from '../ChatMessages'
import { useUnreadMessages } from '../ChatMessages/useUnreadMessages'

interface Props {
    isExpanded?: boolean
}

const ActiveChatMessageView: React.FC<Props> = ({ isExpanded }) => {
    const { messages, isTyping, unread, id } = useChatConnections('selected')!

    const { messagesContainer } = useUnreadMessages(id, messages, isTyping)

    return (
        <ChatMessages
            ref={messagesContainer}
            messages={messages ?? []}
            unread={unread}
            isTyping={isTyping}
            isExpanded={isExpanded}
        />
    )
}

export default ActiveChatMessageView
